import templateUrl from "emun.order/parts/parts-order-details-actions.htm";

export default () => ({ templateUrl });
